/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-horizontal[_ngcontent-%COMP%]{padding:0 14px}.center[_ngcontent-%COMP%]{text-align:center}.checkMark[_ngcontent-%COMP%]{font-size:48px;color:#6bd47b}.mt4[_ngcontent-%COMP%]{margin-top:4rem}.title[_ngcontent-%COMP%]{font-size:18px;color:#333}.confirmation[_ngcontent-%COMP%]{margin-bottom:0}.confirmMail[_ngcontent-%COMP%]{margin-top:5px;color:#333}.session-venue-svg[_ngcontent-%COMP%]{width:1.2rem;color:#d7d7d7}.notes[_ngcontent-%COMP%]{color:#337ab7}"];
export { styles as styles };
